import request from '@/utils/request'

/** 登录 */
export function login(data) {
  return request.post('/web/login', data)
}

/** 注册 */
export function register(data) {
  return request.post('/web/register', data)
}

/** 退出 */
export function logout() {
  return request.post('/web/logout')
}

/** 当前用户信息 */
export function getProfile() {
  return request.get('/web/profile')
}

/** 更新资料 */
export function updateProfile(data) {
  return request.put('/web/profile', data)
}

/** 修改密码 */
export function changePassword(data) {
  return request.post('/web/password', data)
}
